<template>
  <a-card :bordered="false">
    <a-form ref="form" :model="search" :initialValues="search" layout="inline">
      <a-form-item label="请选择">
        <a-range-picker
          v-model:value="search.search_time"
          valueFormat="YYYY-MM-DD"
          format="YYYY-MM-DD"
          :disabled-date="disabledDate"
          :defaultPickerValue="defaultValue"
          @calendarChange="calendarPriceRangeChange"
          @change="changePriceRangeDate"
        />
      </a-form-item>

      <a-form-item>
           <a-select
          v-model:value="search.sort"
          style="width: 200px"
          @focus="focus"
          ref="select"
          @change="handleChange"
        >
          <!-- <a-select-option value="1">商品数量从多到少排序</a-select-option> -->
          <a-select-option value="2">下单次数从多到少排序</a-select-option>
          <a-select-option value="3">支付积分从多到少排序</a-select-option>
          <a-select-option value="4">支付金额从多到少排序</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item>
        <a-button type="primary" htmlType="submit" @click="init">搜索</a-button>
        <a-button type="primary" htmlType="submit" class="m-l-20" v-has:integralStatisticsUserExport="exportTable">导出列表</a-button>
      </a-form-item>
    </a-form>
  </a-card>
  <a-card :bordered="false">
    <!-- <div class="m-t-10 m-b-10">商品明细</div> -->
    <h4 style="background:#f2f2f2;padding:15px" class="m-b-20">列表最多显示符合条件的前100名消费者信息</h4>
    <a-table
      :pagination="pagination"
      :loading="loading"
      bordered
      rowKey="user_id"
      :columns="columns"
      :data-source="tableList"
      @change="handleTableChange"
    >
      <!-- <template v-slot:action="{ record }">
        <a-button
          @click="
            $router.push({
              path: '/onlineOrder/statics/storeOrderStatics/detail',
              query: {
                buyer_id: record.buyer_id,
                search_date_type: search.search_date_type,
                search_time: search.search_time,
                weekTime: weekTime,
              },
            })
          "
          >查看详情</a-button
        >
      </template> -->
    </a-table>
    <!-- <a-pagination
      :style="{ marginTop: '20px', textAlign: 'right' }"
      show-size-changer
      show-quick-jumper
      :current="search.page"
      :page-size="search.limit"
      :total="total"
      @change="pageCurrentChange"
      @showSizeChange="pageSizeChange"
      :show-total="(total) => `总数: ${total} `"
    /> -->
  </a-card>
  <a-modal
    title="选择经销商"
    centered
    v-model:visible="showDealer"
    :width="1000"
    :footer="null"
    destroyOnClose
  >
    <selectDealer v-on:select="dealerSelect"></selectDealer>
  </a-modal>
</template>
<script>
import { useTime } from "@/hooks/utils/useTime";
import { reactive, ref, toRefs } from "vue";
import { iscode } from "@/utils/app";
import {  onMounted } from "@vue/runtime-core";
import {productStatistics,consumerStatistics} from '@/api/integralShop'
 import { message } from "ant-design-vue";
import moment from "moment";
const def = {
  sort: "2",
  search_time: "",
  limit: 10,
  page: 1,
   end_time:'',
  start_time:''
};
export default {

  setup() {
    const search = ref({...def});
    let columns = [
      {
        title: "会员ID",
        dataIndex: "user_id",
        key: "user_id",
      },
      {
        title: "微信昵称",
         dataIndex: "member_name",
        key: "member_name",
        customRender:function({record}){
          return record.member_name || '-'
        }
      },
      {
        title: "会员等级",
         dataIndex: "vip_name",
        key: "vip_name",
      },
      {
        title: "下单次数",
        dataIndex: "order_total",
        key: "order_total",
      },
      {
        title: "支付积分（个）",
         dataIndex: "pay_point_total",
        key: "pay_point_total",
      },
       {
        title: "支付金额（元）",
        dataIndex: "pay_price_total",
        key: "pay_price_total",
        
      }
    ];
    const state = reactive({
      active: "1",
      showDealer: false,
      selectPriceDate: "",
      offsetDays: 86400000 * 90,
      defaultValue:[],
       tableList:[],
       pagination:{ //分页
        total:0,
        current:1,
        pageSize:10
      },
      loading: false,
      is_day:true
    });
    const dateTime = reactive({
      dayTime: "",
      weekTime: "",
      monthTime: "",
      quarterTime: "",
      time: [],
    });
    const {dataBefore } = useTime();

  
    
    const detail = ref();
 
  

    onMounted(async () => {
    search.value.search_time = [dataBefore(),dataBefore()]
    search.value.start_time = search.value.search_time[0]
    search.value.end_time = search.value.search_time[1]
      methods.init()
    });
  
    //


    //
    const methods = {
      disabledDate(current) {

        if (state.selectPriceDate) {
             
          let selectV = moment(state.selectPriceDate, 'YYYY-MM-DD').valueOf()
          return (current > moment().subtract(1, "days") || current >moment(new Date(selectV + state.offsetDays), "YYYY-MM-DD")) || current < moment(new Date(selectV - state.offsetDays), "YYYY-MM-DD")
        } else {
           return current && current > moment().subtract(1, "days");
        }
      },
      changePriceRangeDate(e) {
        state.is_day = !!e[0];
        state.selectPriceDate = "";
      },
      //选择开始时间/结束时间
      calendarPriceRangeChange(date) {
        state.selectPriceDate = date[0];
      },
       disabledDateValue(current){
           return current && current > moment().endOf('day')
       },
       handleChange(val){
           search.value.search_date_type =val
       },
        async exportTable(){ //导出
        search.value.start_time = search.value.search_time[0]
        search.value.end_time = search.value.search_time[1]
        let result=await consumerStatistics({...search.value,excel:1}).then(res=>res.data).catch(error=>error)
        if(iscode(result,true)){
          window.open(result.data.action)
        }
      },
       async init(){
          if(!state.is_day){
         message.error("请选择日期！");
        return;
      }
        const hide = message.loading("正在加载中...", 0);
         state.pagination.current=1;
        search.value.page = 1;
        state.tableList = [];
       await methods.getSearch()
        setTimeout(hide);
      },
       async getSearch(){
        state.loading = true;
        state.tableList = [];
        search.value.start_time = search.value.search_time[0]
        search.value.end_time = search.value.search_time[1]
        let res = await consumerStatistics({...search.value}).then(res=>res.data)
         state.loading = false;
        if(iscode(res)){
          state.tableList = res.data.data || [];
          state.pagination.total = res.data.total || 0;
        }else{
          state.tableList = [];
          message.error(res.msg)
        }
      },
       handleTableChange(e) {
         state.tableList = []
        state.pagination.current=e.current;
        search.value.page = e.current;
        methods.getSearch()
      }
    };

     const isData = function(val){
      state.is_day = !!val
    }

    return {
      ...toRefs(dateTime),
      ...toRefs(state),
      search,
     isData,
      columns,
      ...methods,
    };
  },
};
</script>
<style lang="less" scoped>
.data-content-nav {
  background: #eee;
  border-radius: 10px;

  .data-content-nav-item {
    color: #8e8e8e;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
    text-align: center;
    .title {
      font-size: 16px;
      color: #000000;
    }

    .num {
      font-size: 34px;
      color: #000;
    }
    &.active {
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
      border-radius: 10px;
    }
  }
}

</style>